import { Badge } from '@time-line/components/common';

interface ProductConfiguratorBadgeProps {
  variant: 'mostPopular' | 'bestValue';
}

const VARIANTS = {
  mostPopular: {
    badgeVariant: 'solid',
    label: 'Clinically Recommended',
  },
  bestValue: {
    badgeVariant: 'subtle',
    label: 'Best Value',
  },
};

export function ProductConfiguratorBadge({
  variant,
}: ProductConfiguratorBadgeProps) {
  return (
    <Badge
      variant={VARIANTS[variant].badgeVariant}
      colorScheme="gray"
      pos="absolute"
      top="-6px"
      right="xs"
      outline="4px solid"
      outlineColor="gray.50"
      borderRadius="base"
      height="21px"
      px="4xs"
      lineHeight={1}
      fontWeight="medium"
      fontSize="3xs-mono"
    >
      {VARIANTS[variant].label}
    </Badge>
  );
}
